import React, {
    useState, useEffect 
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

export const Wrapper = styled.aside`
    position: sticky;
    top: ${({ theme }) => theme.subnav.height};
    width: ${({ theme }) => theme.filter.width};
    height: calc(100vh - ${({ theme }) => theme.subnav.height});
    background-color: ${COLORS.mlbGrey7};
    border-right: 1px solid ${COLORS.mlbGrey6};
    overflow-y: scroll;
    overflow-x: hidden;

    ${({ hasCustomScrollbar }) => hasCustomScrollbar ? `
            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background-color: ${COLORS.mlbGrey7};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${COLORS.mlbGrey6};
                border-radius: 20px;
            }
  
            /* Firefox from version 64 */
            scrollbar-color: ${COLORS.mlbGrey6} ${COLORS.mlbGrey7};
            scrollbar-width: thin;
    ` : ''}
    }
`;

const Filter = ({
    children,
    isFilterActive,
}) => {

    const [
        loadFilter,
        setLoadFilter,
    ] = useState(isFilterActive);

    const [
        hasCustomScrollbar,
        setHasCustomScrollbar,
    ] = useState(false);


    useEffect(() => {

        setHasCustomScrollbar(navigator.platform.indexOf('Mac') === -1);

    }, []);

    useEffect(() => {

        if (!loadFilter && isFilterActive) {

            setLoadFilter(true);

        }

    }, [
        loadFilter,
        isFilterActive,
        setLoadFilter,
    ]);

    return (
        <Wrapper hasCustomScrollbar={hasCustomScrollbar}>
            {loadFilter && children}
        </Wrapper>
    );

};

Filter.propTypes = {
    children: PropTypes.element.isRequired,
    isFilterActive: PropTypes.bool.isRequired,
};

export default Filter;
